import { render } from "./Week.vue?vue&type=template&id=e5138642&scoped=true&ts=true"
import script from "./Week.vue?vue&type=script&lang=ts"
export * from "./Week.vue?vue&type=script&lang=ts"

import "./Week.vue?vue&type=style&index=0&id=e5138642&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5138642"]])

export default __exports__